import moment from 'moment';

export function getFormattedDate(date: any, time: string) {
    if (date && time) {
        const myDate = moment(
            date?.format('MM/DD/YYYY') +
            'T' +
            time,
            'MM/DD/YYYY hh:mm ZZ'
        );
        return myDate;
    }
    return null;
}

export function updateOutageModel(sideSheetData: any, userInfo:any) {
    const createdDateTime = getFormattedDate(sideSheetData.createdDate, sideSheetData.createdTime);
    const applications = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.id) : null;
    const applicationNames = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.label) : null;
    const workflows = sideSheetData.targetWorkflows?.length > 0 ?
        sideSheetData.targetWorkflows.map((wflow: any) => wflow.id) : null;
        const lastUpdatedBy = userInfo.userProfile.email;
        const lastUpdatedDate=  getFormattedDate(moment(), moment().format("hh:mm"));
        const createdBy = sideSheetData.createdBy;
    const selectedUploadedEnterprises = sideSheetData.gridEnterpriseData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedCNumbers = sideSheetData.gridCNumberData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedStores = sideSheetData.gridStoresData?.filter((item: any) => item.isSelected).map((item: any) => item.name);

    const model = {
        body: sideSheetData.body,
        caseId: sideSheetData.caseId,
        title: sideSheetData.title,
        bodyLocale: sideSheetData.bodyLocale,
        titleLocale: sideSheetData.titleLocale,
        subjectLocale: sideSheetData.subjectLocale,
        externalUrlLocale: sideSheetData.linkToLearnMoreLocale,
        target: {
            workflow: workflows,
            enterpriseIds: selectedUploadedEnterprises?.length > 0 ? selectedUploadedEnterprises : sideSheetData.targetEnterprises?.length > 0 ?
                sideSheetData.targetEnterprises.split(",").map((enterprise: string) => enterprise.trim()) : null,
            cnumbers: selectedUploadedCNumbers?.length > 0 ? selectedUploadedCNumbers : sideSheetData.targetCNumbers?.length > 0 ?
                sideSheetData.targetCNumbers.split(",").map((cnumber: string) => cnumber.trim()) : null,
            stores: selectedUploadedStores?.length > 0 ? selectedUploadedStores : sideSheetData.targetStores?.length > 0 ?
                sideSheetData.targetStores.split(",").map((store: string) => store.trim()) : null,
            application: applications,
        },
        externalUrl: sideSheetData.linkToLearnMore,
        subject: sideSheetData.subject,
        createdDate: createdDateTime,
        type: 'outage',
        source: 'unifyAdmin',
        application: applicationNames ? applicationNames.join(",") : '',
        startDate: sideSheetData.outageType === 'Planned' ?
            getFormattedDate(sideSheetData.startDate, sideSheetData.startTime) : null,
        endDate:
            getFormattedDate(sideSheetData.endDate, sideSheetData.endTime),
            createdBy: createdBy,
            lastUpdatedBy: lastUpdatedBy,
            lastUpdatedDate: lastUpdatedDate
    };
    return model;
}


export const createOutageModel = (sideSheetData: any, userInfo: any) => {

    const createdDateTime = getFormattedDate(sideSheetData.createdDate, sideSheetData.createdTime);
    const applications = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.id) : null;
    const applicationNames = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.label) : null;
    const workflows = sideSheetData.targetWorkflows?.length > 0 ?
        sideSheetData.targetWorkflows.map((wflow: any) => wflow.id) : null;
    const selectedUploadedEnterprises = sideSheetData.gridEnterpriseData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedCNumbers = sideSheetData.gridCNumberData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedStores = sideSheetData.gridStoresData?.filter((item: any) => item.isSelected).map((item: any) => item.name);

    const model = {
        body: sideSheetData.body,
        caseId: sideSheetData.caseId,
        title: sideSheetData.title,
        bodyLocale: sideSheetData.bodyLocale,
        titleLocale: sideSheetData.titleLocale,
        subjectLocale: sideSheetData.subjectLocale,
        externalUrlLocale: sideSheetData.linkToLearnMoreLocale,
        target: {
            workflow: workflows,
            enterpriseIds: selectedUploadedEnterprises?.length > 0 ? selectedUploadedEnterprises : sideSheetData.targetEnterprises?.length > 0 ?
                sideSheetData.targetEnterprises.split(",").map((enterprise: string) => enterprise.trim()) : null,
            cnumbers: selectedUploadedCNumbers?.length > 0 ? selectedUploadedCNumbers : sideSheetData.targetCNumbers?.length > 0 ?
                sideSheetData.targetCNumbers.split(",").map((cnumber: string) => cnumber.trim()) : null,
            stores: selectedUploadedStores?.length > 0 ? selectedUploadedStores : sideSheetData.targetStores?.length > 0 ?
                sideSheetData.targetStores.split(",").map((store: string) => store.trim()) : null,
            application: applications,
        },
        externalUrl: sideSheetData.linkToLearnMore,
        subject: sideSheetData.subject,
        createdDate: createdDateTime,
        type: 'outage',
        source: 'unifyAdmin',
        application: applicationNames ? applicationNames.join(",") : '',
        startDate: sideSheetData.outageType === 'Planned' ?
            getFormattedDate(sideSheetData.startDate, sideSheetData.startTime) : null,
        endDate: sideSheetData.outageType === 'Planned' ?
            getFormattedDate(sideSheetData.endDate, sideSheetData.endTime) : null,
        createdBy: userInfo?.userProfile?.email
    };
    return model;
}

export const createFeatureModel = (sideSheetData: any, userProfile: any, action?: string) => {
    const applications = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.id) : null;

    const applicationNames = sideSheetData.targetApplications?.length > 0 ?
        sideSheetData.targetApplications.map((app: any) => app.label) : null;
    const workflows = sideSheetData.targetWorkflows?.length > 0 ?
        sideSheetData.targetWorkflows.map((wflow: any) => wflow.id) : null;
    const selectedUploadedEnterprises = sideSheetData.gridEnterpriseData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedCNumbers = sideSheetData.gridCNumberData?.filter((item: any) => item.isSelected).map((item: any) => item.name);
    const selectedUploadedStores = sideSheetData.gridStoresData?.filter((item: any) => item.isSelected).map((item: any) => item.name);

    const departments = sideSheetData.targetDepartments?.length > 0 ?
        sideSheetData.targetDepartments.map((dept: any) => dept.id) : null;

    let lastUpdatedBy;
    let lastUpdatedDate;
    let createdBy;
    if (action && action === "update") {
        lastUpdatedBy = userProfile.userProfile.email;
        lastUpdatedDate = getFormattedDate(moment(), moment().format("hh:mm"));
        createdBy = sideSheetData.createdBy;
    } else {
        createdBy = userProfile?.userProfile?.email;
    }

    const model = {
        body: sideSheetData.body,
        title: sideSheetData.title,
        bodyLocale: sideSheetData.bodyLocale,
        titleLocale: sideSheetData.titleLocale,
        subjectLocale: sideSheetData.subjectLocale,
        externalUrlLocale: sideSheetData.linkToLearnMoreLocale,
        target: {
            workflow: workflows,
            department: departments,
            enterpriseIds: selectedUploadedEnterprises?.length > 0 ? selectedUploadedEnterprises : sideSheetData.targetEnterprises?.length > 0 ?
                sideSheetData.targetEnterprises.split(",").map((enterprise: string) => enterprise.trim()) : null,
            cnumbers: selectedUploadedCNumbers?.length > 0 ? selectedUploadedCNumbers : sideSheetData.targetCNumbers?.length > 0 ?
                sideSheetData.targetCNumbers.split(",").map((cnumber: string) => cnumber.trim()) : null,
            stores: selectedUploadedStores?.length > 0 ? selectedUploadedStores : sideSheetData.targetStores?.length > 0 ?
                sideSheetData.targetStores.split(",").map((store: string) => store.trim()) : null,
            application: applications,
        },
        externalUrl: sideSheetData.linkToLearnMore,
        subject: sideSheetData.subject,
        createdDate: sideSheetData.createdDate,
        type: 'release',
        source: 'unifyAdmin',
        application: applicationNames ? applicationNames.join(",") : '',
        startDate:
            getFormattedDate(sideSheetData.startDate, sideSheetData.startTime),
        endDate:
            getFormattedDate(sideSheetData.endDate, sideSheetData.endTime),
        createdBy: createdBy,
        includeTargets: sideSheetData.includeTargets
    };

    if (action && action === "update") {
        Object.assign(model, { lastUpdatedBy: lastUpdatedBy, lastUpdatedDate: lastUpdatedDate })
    }

    return model;
}

export const translationModel = (sideSheetData: any, lang: string) => {
    const localeData = [
        { "Text": sideSheetData.title },
        { "Text": sideSheetData.body },
        { "Text": sideSheetData.subject }
    ];

    // Mapping app locales to Azure locales
    const azureLangMap: Record<string, string> = {
        enCA: "en",     // map Canada English → neutral English
        frCA: "fr-CA",  // Canada French supported directly
        enUS: "en",     // US English → neutral English
    };

    const model = {
        toLocale: azureLangMap[lang] || lang,
        fromLocale: ["en"],  // assuming source is US English
        localeData,
    };

    return model;
};
